'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { notFound } from 'next/navigation';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const router = useRouter();

  useEffect(() => {
    if (error.message.includes('403')) {
      router.push('/forbidden');
    } else if (
      error.message.includes('404') ||
      error.message.includes('ENOENT')
    ) {
      notFound();
    }
  }, [error, router]);

  return null;
}
